import React, {useCallback, useLayoutEffect, useMemo, useState} from 'react';
import OverView from './Overview';
import Analytics from './Analytics';
import MostRecentActivity from './MostRecentActivity';
import DetectionTypesSection from './detection-types/DetectionTypesSection';
import { ReactComponent as Spinner } from '../../assets/icons/spinner.svg';

const createDefaultModules = () => ({
  live: false,
  when_started: false,
  traffic: false,
  platform: false,
  campaign: false,
});

const Content = ({site, loadingMessage = null}) => {
  const [modules, setModules] = useState(createDefaultModules);

  const setReady = useCallback((module) => {
    if (!site) return;

    setModules((prev) => {
      if (prev[module]) return prev;
      return {...prev, [module]: true};
    });
  }, [site]);

  useLayoutEffect(() => {
    setModules(createDefaultModules());
  }, [site]);

  const isReady = useMemo(
    () => (site ? Object.values(modules).every(Boolean) : false),
    [modules, site]
  );

  const loadingStateMessage = loadingMessage || (site && !isReady ? 'Parsing data...' : null);

  return (
    (site || loadingStateMessage) ? (
      <div
        className={`page-content-shell${loadingStateMessage ? ' is-loading' : ''}`}
        aria-busy={loadingStateMessage ? 'true' : undefined}
      >
        {site && (
          <>
            <OverView site={site} setReady={setReady} />
            <Analytics site={site} setReady={setReady} />
            <MostRecentActivity site={site} />
            <DetectionTypesSection site={site} />
          </>
        )}
        {loadingStateMessage && (
          <div className="site-overview__loading-view spinner" aria-live="polite" aria-busy="true">
            <Spinner className="site-overview__loading-spinner" />
            <p className="site-overview__loading-text">{loadingStateMessage}</p>
          </div>
        )}
      </div>
    ) : null
  );
}

export default Content;
